var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloud = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9145 6.558C12.4588 4.2034 10.3983 2.50202 8 2.5V3.5C9.91851 3.50257 11.5666 4.8632 11.9325 6.7465L12.062 7.4195L12.7365 7.542C14.1363 7.79538 15.1121 9.07421 14.9868 10.4913C14.8615 11.9083 13.6766 12.9961 12.254 13H8V14H12.254C14.1941 13.9958 15.8108 12.5129 15.9822 10.5804C16.1535 8.64789 14.823 6.90359 12.914 6.558H12.9145ZM4 12H7V13H4V12ZM2 12H3V13H2V12ZM3 10H7V11H3V10ZM1 10H2V11H1V10ZM4 8H7V9H4V8ZM2 8H3V9H2V8ZM5 6H7V7H5V6ZM3 6H4V7H3V6ZM6 4H7V5H6V4Z",
    fill: "#0062FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud.20b3b706.svg";
export { ForwardRef as ReactComponent };